module.exports = __webpack_public_path__ + "img/shoplist.763f526e.png";